<template>
  <div class="tag-anchor enter" :style="styles" :id="$attrs._id">
    <div
      class="tag-anchor__pos"
      :class="`tag-anchor__pos--tail-${tailPosition ? tailPosition : 'none'}`"
    >
      <div class="tag-reveal" :class="classes">
        <div class="tag-reveal__inner">
          <div
            v-if="label"
            class="tag-reveal__content-col"
            :class="{ 'dir-rtl': activeLanguage.rtl }"
          >
            <div
              class="tag-reveal__label"
              v-html="label[activeLanguage.code]"
            ></div>
            <div
              class="tag-reveal__description"
              v-html="description[activeLanguage.code]"
            ></div>
          </div>
          <div class="tag-reveal__image-col" v-if="asset && asset._id">
            <img
              class="tag-reveal__image"
              :src="
                `${$store.state.assetsPath}${
                  asset.customThumbPath
                    ? asset.customThumbPath
                    : asset.thumbPath
                }`
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "pos",
    "flip",
    "overlayContent",
    "label",
    "type",
    "tail-position",
    "description",
    "image",
    "asset",
    "box-shadow"
  ],

  computed: {
    activeLanguage() {
      return this.$store.getters.activeLanguage;
    },
    classes() {
      let classes = {};
      classes[`tag-reveal--tail-${this.tailPosition}`] = true;
      classes["tag-reveal--flip"] = this.forceFlip;
      classes["tag-reveal--overlay-content"] = this.overlayContent;
      classes["tag-reveal--box-shadow"] = this.boxShadow !== false;
      return classes;
    },

    forceFlip() {
      if (this.tailPosition.includes("right-center")) {
        return true;
      }

      if (this.tailPosition.includes("left-center")) {
        return false;
      }

      return this.flip;
    },

    styles() {
      return {
        left: `${this.pos.x / 20}em`,
        top: `${this.pos.y / 20}em`
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

$tag-tail-length: 8em;

.tag-anchor {
  font-size: 1em;
  cursor: pointer;
  pointer-events: auto;
  position: absolute;
  transform: translateY(1em);
  transition: opacity 200ms ease-in-out, box-shadow 200ms ease-in-out;
  z-index: 15;

  &.inactive {
    opacity: 0.5 !important;
  }

  &__pos {
    color: $rich-tag-bg-color;
    height: 0;
    width: 0;

    &::after {
      @include tailDot(currentColor);
    }

    &--tail-none {
      &::after {
        content: none !important;
      }
    }

    &--tail-top-left:before,
    &--tail-top-center:before,
    &--tail-top-right:before {
      background: currentColor;
      box-shadow: none;
      content: "";
      height: $tag-tail-length;
      left: 0;
      position: absolute;
      top: 0;
      transform: translateX(-50%);
      width: 0.25em;
      z-index: 10;
    }

    &--tail-bottom-left:before,
    &--tail-bottom-center:before,
    &--tail-bottom-right:before {
      background: currentColor;
      bottom: 0;
      box-shadow: none;
      content: "";
      height: $tag-tail-length;
      left: 0;
      position: absolute;
      transform: translateX(-50%);
      width: 0.25em;
      z-index: 10;
    }

    &--tail-left-center:before {
      background: currentColor;
      bottom: -50%;
      box-shadow: none;
      content: "";
      height: 0.25em;
      left: 0;
      position: absolute;
      transform: translateY(50%);
      width: $tag-tail-length;
    }

    &--tail-right-center:before {
      background: currentColor;
      bottom: -50%;
      box-shadow: none;
      content: "";
      height: 0.25em;
      right: 0;
      position: absolute;
      transform: translateY(50%);
      width: $tag-tail-length;
    }
  }

  div[class^="tag-reveal--tail-top"],
  div[class*=" tag-reveal--tail-top"] {
    .tag-reveal__inner {
      transform-origin: top;
    }
  }

  div[class^="tag-reveal--tail-bottom"],
  div[class*=" tag-reveal--tail-bottom"] {
    .tag-reveal__inner {
      transform-origin: bottom;
    }
  }

  div[class^="tag-reveal--tail-right"],
  div[class*=" tag-reveal--tail-right"] {
    .tag-reveal__inner {
      transform-origin: right;
    }
  }

  div[class^="tag-reveal--tail-right-center"],
  div[class*=" tag-reveal--tail-right-center"] {
    .tag-reveal__inner {
      transform-origin: center;
    }
  }

  div[class^="tag-reveal--tail-left"],
  div[class*=" tag-reveal--tail-left"] {
    .tag-reveal__inner {
      transform-origin: left;
    }
  }

  &.enter {
    opacity: 1;
    transform: translateY(0);

    .tag-reveal__image-col .tag-reveal__image,
    .tag-reveal__image-col .tag-reveal__video {
      transform: translateX(0);
      // transition: all 750ms ease-out 350ms;
    }
  }

  &.leave {
    .tag-reveal__image-col .tag-reveal__image,
    .tag-reveal__image-col .tag-reveal__video {
      transform: translateX(0);
      // transition: all 750ms ease-out 350ms;
    }
  }
}

.tag-reveal {
  background-color: transparent;
  color: $rich-tag-font-color;
  font-family: $touchscreen-font;
  font-size: $rich-tag-font-size;
  height: 15em;
  letter-spacing: 0.05em;
  line-height: 1.2em;
  overflow: visible;
  pointer-events: none;
  position: absolute;
  // transition: all 350ms ease-in-out;
  width: 18em;
  z-index: 5;

  * {
    pointer-events: none;
    user-select: none;
  }

  &--flip {
    .tag-reveal__inner {
      transform-origin: left;

      &--expand {
        .tag-reveal__content-col-extra {
          border-bottom-left-radius: $rich-tag-border-radius;
          border-top-left-radius: $rich-tag-border-radius;
          border-bottom-right-radius: 0;
          border-top-right-radius: 0;
          transform: translateX(-95%);
        }
      }
    }

    .tag-reveal__image-col {
      transform: translateX(-195%);

      .tag-reveal__image-clip {
        clip-path: polygon(
          98% 0%,
          96% 1%,
          95.5% 2%,
          95% 3%,
          95% 50%,
          95% 97%,
          95.5% 98%,
          96% 99%,
          98% 100%,
          0% 100%,
          0% 50%,
          0% 0%
        );
        height: 100%;
      }

      .tag-reveal__image {
        height: 100%;
        transform: translateX(92%);
        width: 100%;
        object-fit: cover;
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }

      .tag-reveal__video {
        height: 100%;
        transform: translateX(92%);
        width: 100%;
        object-fit: cover;
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }

  &--overlay-content {
    .tag-reveal__inner {
      width: 18em;
    }

    .tag-reveal__content-col,
    .tag-reveal__image-col {
      position: absolute;
      width: 100%;
    }

    .tag-reveal__content-col {
      background: rgba(0, 0, 0, 0.5);
    }

    .tag-reveal__image-col {
      border-radius: $default-border-radius;
      transform: translateX(0);
    }

    .tag-reveal__image-clip {
      clip-path: none !important;
    }
  }

  &--tail-top-left {
    left: -$rich-tag-font-size * 2;
    top: $tag-tail-length / $rich-tag-font-size + em;
  }

  &--tail-top-center {
    left: 50%;
    top: $tag-tail-length / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-top-right {
    right: -$rich-tag-font-size * 2;
    top: $tag-tail-length / $rich-tag-font-size + em;
  }

  &--tail-bottom-left {
    left: -$rich-tag-font-size * 2;
    bottom: $tag-tail-length / $rich-tag-font-size + em;
  }

  &--tail-bottom-center {
    left: 50%;
    bottom: $tag-tail-length / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-bottom-right {
    right: -$rich-tag-font-size * 2;
    bottom: $tag-tail-length / $rich-tag-font-size + em;
  }

  &--tail-left-center {
    left: $tag-tail-length / $rich-tag-font-size + em;
    transform: translateY(-50%);
  }

  &--tail-right-center {
    right: $tag-tail-length / $rich-tag-font-size + em;
    transform: translateY(-50%);
  }

  &__inner {
    display: flex;
    height: 15em;
    position: absolute;
    // transition: transform 300ms ease;
    width: 36em;

    &--expand {
      transform: scale(1.25);

      .tag-reveal__content-col-extra {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        transform: translateX(97%);
      }
    }
  }

  &__image-col {
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%;
    left: 0;
    top: 0;
    width: 50%;
    filter: none;
    overflow: hidden;
    pointer-events: auto;
    transform: translateX(-3%);
  }

  &__image-clip {
    clip-path: polygon(
      100% 0%,
      100% 50%,
      100% 100%,
      0% 100%,
      2% 99%,
      2.5% 98%,
      3% 97%,
      3% 50%,
      3% 3%,
      2.5% 2%,
      2% 1%,
      0% 0%
    );
    height: 100%;
  }

  &__image {
    height: 100%;
    transform: translateX(-92%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  &__video {
    height: 100%;
    transform: translateX(-92%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  &__content-col {
    background: $rich-tag-bg-color;
    border-radius: $rich-tag-border-radius;
    box-shadow: none;
    height: 100%;
    overflow: hidden;
    padding: 1.5em;
    pointer-events: auto;
    position: relative;
    width: 50%;
    z-index: 2;
  }

  &__content-col-extra {
    background: rgba($rich-tag-bg-color, 0.8);
    border-radius: $rich-tag-border-radius;
    box-shadow: none;
    height: 100%;
    left: 0;
    overflow: hidden;
    padding: 1.5em;
    pointer-events: auto;
    position: absolute;
    // transition: 300ms all 100ms ease-in-out;
    width: 50%;
    z-index: 1;
  }

  &__label {
    font-size: 1.3em;
    font-weight: 300;
    line-height: 1.1em;
    margin-bottom: 0.6em;
    margin-top: 0.1em;
    -webkit-font-smoothing: auto;
  }

  &__description {
    font-size: 0.75em;
    font-weight: 200;
    line-height: 1.4;
  }

  &__info-icon {
    bottom: 0.5em;
    font-size: 0.8em;
    position: absolute;
    right: 0.75em;
  }

  &--box-shadow {
    .tag-reveal__content-col {
      box-shadow: $tag-box-shadow;
    }

    .tag-reveal__image-col {
      filter: drop-shadow($tag-box-shadow);
    }
  }
}
</style>
